import React, { useEffect } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import { Page } from '../../components/atoms/layout/Page';
import { NotificationDeliveryShowPageState } from './NotificationDeliveryShowPageState';
import { NotificationDeliveryToken, NotificationDeliveryStatus } from '../../types/notification_deliveries';
import { restrictAccessForUser } from '../../../commonv3/hooks/restrictAccessForUser';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { NotificationDeliveryShowPageHeader } from './NotificationDeliveryShowPageHeader';
import './notificationDeliveryShowPage.module.scss';
import { V3Routes } from '../../routes/index';
import { useNotificationIconState } from '../../contexts/notificationIcon';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';
import { PageHeader } from '../../components/atoms/layout/PageHeader';

type Props = {
  match: {
    params: {
      notificationToken: NotificationDeliveryToken;
    };
  };
};

export const NotificationDeliveryShowPage = observer(
  ({
    match: {
      params: { notificationToken },
    },
  }: Props) => {
    restrictAccessForUser();
    useNavigation(NavigationSpecs.side());

    const notificationState = useNotificationIconState();

    const { pageState } = useLocalStore(() => ({
      pageState: new NotificationDeliveryShowPageState(notificationState),
    }));

    useEffect(() => {
      pageState.init(notificationToken);
    }, []);

    const { notificationDelivery: notificationDeliveryResource } = pageState;
    const entityType = 'お知らせ';

    if (notificationDeliveryResource.loading) {
      return <LoaderRow />;
    }
    if (notificationDeliveryResource.isEmpty()) {
      return <NotFoundPage entityType={entityType} />;
    }

    const notificationDelivery = notificationDeliveryResource.get();
    const notificationDeliveryStatus = notificationDelivery.notification.delivery_status;
    const content = notificationDelivery.notification.content;

    if (notificationDeliveryStatus === NotificationDeliveryStatus.CANCELLED) {
      return <NotFoundPage entityType={entityType} />;
    }

    const breadCrumbItems = [
      { text: 'お知らせ', to: V3Routes.NotificationDeliveryListPage() },
      { text: notificationDelivery.notification.title },
    ];

    return (
      <Page styleName="notification-show-page" id="notification-show-page">
        <BreadCrumb items={breadCrumbItems} hasHome />
        <PageHeader title="MESSAGE" />
        <NotificationDeliveryShowPageHeader key={notificationDelivery.id} notificationDelivery={notificationDelivery} />
        <div styleName="content" data-value="content" dangerouslySetInnerHTML={{ __html: content }} />
      </Page>
    );
  }
);
